'use client'

import { IChildrenProps } from '@/utils/typings/children-props'
import { createContext, useContext, useState } from 'react'

type IDirectoryDragContext = {
    internalDraggedNodePath: string | null
    setInternalDraggedNodePath: (uuid: string | null) => void
    draggedOverDirectoryPath: string | null
    setDraggedOverDirectoryPath: (uuid: string | null) => void
}

const DirectoryDragContext = createContext<IDirectoryDragContext | null>(null)

export type IDirectoryContextProviderProps = IChildrenProps

export const DirectoryDragContextProvider = ({ children }: IDirectoryContextProviderProps) => {
    const [internalDraggedNodePath, setInternalDraggedNodePath] = useState<string | null>(null)
    const [draggedOverDirectoryPath, setDraggedOverDirectoryPath] = useState<string | null>(null)

    return (
        <DirectoryDragContext.Provider
            value={{
                internalDraggedNodePath,
                setInternalDraggedNodePath,
                draggedOverDirectoryPath,
                setDraggedOverDirectoryPath,
            }}
        >
            {children}
        </DirectoryDragContext.Provider>
    )
}

export const useDirectoryDragContext = () => {
    const context = useContext(DirectoryDragContext)

    if (!context) {
        throw new Error('useDirectoryDragContext must be used within a DirectoryDragContextProvider')
    }

    return context
}
